import { render } from "./OverviewTopNav.vue?vue&type=template&id=29b24f6f&scoped=true&ts=true"
import script from "./OverviewTopNav.vue?vue&type=script&lang=ts"
export * from "./OverviewTopNav.vue?vue&type=script&lang=ts"

import "./OverviewTopNav.vue?vue&type=style&index=0&id=29b24f6f&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b24f6f"]])

export default __exports__